"use client";
import { createContext } from "react";

export interface DrawerOptions {
  isOpen: boolean;
}

export interface LayoutContextProps {
  leftDrawer: DrawerOptions;
  openCloseLeftDrawer: () => void;
}

export const layoutContext = createContext({} as LayoutContextProps);
